export const ApiResultStatus = {
  SUCCESS: {
    CODE: 200,
    MESSAGE: '',
  },
  FAILED: {
    CODE: 400,
    MESSAGE: '',
  },
  NOT_FOUND: {
    CODE: 404,
    MESSAGE: '',
  },
  UNAUTHORIZED: {
    CODE: 401,
    MESSAGE: '',
  },
  FORBIDDEN: {
    CODE: 403,
    MESSAGE: '',
  },
  CONFLICT: {
    CODE: 409,
    MESSAGE: '',
  },
  INTERNAL_SERVER: {
    CODE: 500,
    MESSAGE: '',
  },
};

export default ApiResultStatus;
